<template>
    <div v-bind:class="['form-group', { 'has-error': question.error }]">
        <label v-bind:for="componnentId">{{ question.question }} <span v-if="question.required" class="small" v-bind:class="{ 'span-error' : question.error }"><span aria-hidden="true">*</span> {{ requiredMessage }}</span></label>
        <input v-model="question.answer"
               v-bind:novalidate="isValidationDisabled"
               v-bind:id="componnentId" 
               v-bind:name="componnentId" 
               v-bind:type="question.type" 
               v-bind:value="question.answer"
               v-on:change="question.answer = $event.target.value"
               class="form-control"
               v-bind:aria-invalid="question.error ? 'true' : null"
               v-bind:class="{ 'red-alert' : question.error }">
    </div>
</template>

<script>
    export default {
        name: 'FormInput',
        props: {
            question: Object,
            isValidationDisabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            componnentId() {
                return 'Question' + this.$props.question.msqID;
            },
            requiredMessage() {
                return this.question.error ? this.question.error : 'Required';
            }
        }  
    }
</script>   
